import * as React from 'react'
import { ActionParam } from 'common/types/params/actionParam'

import { BasePath } from 'pc/routes'
import { StoreChannel } from 'common/types/entities/store'
import Error, { MessageTypes } from 'common/components/Error'
import { fetchStore } from 'common/ducks/store/general/store'
import { fetchContentDetail } from 'common/services/content'
import { Content } from 'common/types/entities/mongo/content'
import { getContentUrl, getStoreUrl } from 'common/utils/url'
import { getRelationProduct, RelationProductState } from 'common/ducks/relationProduct'
import { getProductUrlById, getRelationProductUrl } from 'common/services/product'
import { SSChannel } from 'common/types/entities/api/channel'
import { ChannelServiceType, RelationProductType, SubVertical } from 'common/constants'
import { PageType } from 'common/types'
import { TRCode } from 'common/services/naverAnalytics'
import { paramsSerializer } from 'common/utils/paramsSerializer'
import { EventDetailParam } from 'common/types/entities/event'
import { fetchSpecialEvent, getEventDetailUrl } from 'common/services/specialEvent'

export default {
  path: `${BasePath.OUTLINK}`,

  children: [
    {
      path: '/storehome/:id',
      action: async ({ store, params, curState, queryParams }: ActionParam) => {
        const storeId = params.id
        await store.dispatch(fetchStore(curState, storeId, PageType.STORE))
        const storeChannel: StoreChannel = store.getState().store[curState]

        if (!storeChannel || !storeChannel.channel) {
          return {
            component: <Error message={MessageTypes.NOT_FOUND} />,
          }
        }

        const channel = storeChannel.channel
        const hasProductsPage = [SubVertical.FASHION_BRAND, SubVertical.DESIGNER].includes(channel.windowSubVertical)
        const queryString = paramsSerializer(queryParams)
        const redirect = `${getStoreUrl(channel.id, channel.windowSubVertical, false, false)}${
          hasProductsPage ? '/product' : ''
        }${queryString ? `?${queryString}` : ''}`

        if (redirect) {
          return {
            redirect,
          }
        }

        return {
          component: <Error message={MessageTypes.NOT_FOUND} />,
        }
      },
    },
    {
      path: '/news/:id',
      action: async ({ ctx, store, params }: ActionParam) => {
        const id = params.id
        const content: Content = await fetchContentDetail(id)

        if (!content) {
          return {
            component: <Error message={MessageTypes.NOT_FOUND} />,
          }
        }

        const redirect = `${getContentUrl(content, false, false)}`
        if (redirect) {
          return {
            redirect,
          }
        }

        return {
          component: <Error message={MessageTypes.NOT_FOUND} />,
        }
      },
    },
    {
      path: '/relation-products/:relationProductNo',
      action: async ({ store, params, curState, headers, ctx }: ActionParam) => {
        const { relationProductNo } = params
        const relationProductId = `${relationProductNo}_${ChannelServiceType.WINDOW}`

        const referer = ctx && ctx.headers && ctx.headers.referer

        const isIgnoreValidation =
          referer && (referer.includes('sell.storefarm.naver.com') || referer.includes('navercorp.com'))

        await store.dispatch(getRelationProduct(curState, relationProductId, headers, isIgnoreValidation))
        const relationProductState: RelationProductState = store.getState().relationProduct[curState]
        if (!relationProductState.relationProduct) {
          return {
            component: <Error message={MessageTypes.SOLDOUT} />,
            title: MessageTypes.getMessages(MessageTypes.SOLDOUT).title,
          }
        }
        const { channelNo, representChannelProductNo, relationProductType } = relationProductState.relationProduct
        await store.dispatch(fetchStore(curState, channelNo))
        const channel: SSChannel = store.getState().store[curState].channel

        return {
          redirect:
            relationProductType !== RelationProductType.VMD
              ? `${getProductUrlById(representChannelProductNo, channel, false, false, null, false, '#INTRODUCE')}`
              : `${getRelationProductUrl(channel, relationProductNo, false, false, isIgnoreValidation)}`,
        }
      },
    },
    {
      path: '/event/:eventId',
      action: async ({ store, params }: ActionParam) => {
        const { eventId } = params
        const detailParam: EventDetailParam = {
          eventId,
        }
        const result = await fetchSpecialEvent(detailParam)

        return {
          redirect: getEventDetailUrl(result, false, false),
        }
      },
    },
  ],

  action: async ({ next }: ActionParam) => {
    const childRouteResult = await next()
    if (!childRouteResult) {
      return {
        component: <Error message={MessageTypes.NOT_FOUND} />,
      }
    }

    return {
      redirect: childRouteResult.redirect,
      component: childRouteResult.component,
    }
  },
}
